export const handleChangeDataModalEditMobile = (name, value) => ({
    type: 'CHANGE_DATA_MODAL_EDIT_MOBILE', name, value
});